export const GET_WAREHOUSES_SUCCESS = "GET_WAREHOUSES_SUCCESS";
export const GET_WAREHOUSE_SUCCESS  = "GET_WAREHOUSE_SUCCESS";
export const GET_REQUEST_SUCCESS  = "GET_REQUEST_SUCCESS";
export const GET_REQUEST_ERROR    = "GET_REQUEST_ERROR";
